import { useState } from "react";
import Header from "../Component/Header";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";

// const S3_URL = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public";
const S3_URL = "";

const Clubs = () => {
  const [clubs] = useState([
    {
      id: 1,
      name: "ALCHEMIST CLUB",
      image: `${S3_URL}/Images/alchemist_club.png`,
      description: "Empowering students through financial literacy and entrepreneurship",
      mission: "Providing a platform for students to explore, learn, and grow in the realm of finance, entrepreneurship and wealth management.",
      vision: "To create a community of financially empowered students who can drive economic growth, innovation, and positive change."
    },
    {
      id: 2,
      name: "ARCHON CLUB",
      image: `${S3_URL}/Images/archon_club.png`,
      description: "Fostering business acumen and management excellence through experiential learning",
      mission: "Our mission is to provide students with experiential learning opportunities in business and management through projects, simulations, and leadership activities.",
      vision: "To empower students to become dynamic business leaders and effective managers by fostering innovation, entrepreneurship, and teamwork."
    },
    {
      id: 3,
      name: "DIGIBLITZ CLUB",
      image: `${S3_URL}/Images/digiblitz_club.png`,
      description: "Exploring digital technology, coding, and innovative problem-solving solutions",
      mission: "Providing a platform for students to explore, learn, and innovate in the field of digital technology, coding, and problem-solving.",
      vision: "To create a community of tech-savvy students who can drive innovation, creativity, and positive digital transformation."
    },
    {
      id: 4,
      name: "NEON CLUB",
      image: `${S3_URL}/Images/neon_club.png`,
      description: "Creating impactful media through videos, brochures, and digital content",
      mission: "Neon Echoes encourages students to experiment with media—crafting brochures, producing videos, and developing digital content—while building creativity, collaboration, and communication skills, making their ideas heard across the school community.",
      vision: "To inspire imagination and transform ideas into impactful media experiences"
    },
    {
      id: 5,
      name: "SERENITY CLUB",
      image: `${S3_URL}/Images/serenity_club.png`,
      description: "Promoting emotional well-being, empathy, and social awareness",
      mission: "To promote emotional well-being, empathy, and social awareness through discussions, debates, and activities that encourage open-mindedness, self-reflection, and collective growth.",
      vision: "Serenity Squad envisions a school community where students grow into emotionally balanced, empathetic, and socially aware individuals who value equality, respect diverse perspectives, and contribute positively to society."
    },
    {
      id: 6,
      name: "TALK TURN CLUB",
      image: `${S3_URL}/Images/talk_turn_club.png`,
      description: "Fostering creative thinking and innovative marketing strategies",
      mission: "To foster creative thinking, effective communication, and innovative marketing strategies among students, while promoting school spirit and community engagement.",
      vision: "To be the premier incubator for the next generation of marketing leaders, where students bridge the gap between academic theory and real-world brand influence."
    },
    {
      id: 7,
      name: "ECO CLUB",
      image: `${S3_URL}/Images/eco_club.png`,
      description: "Coming soon...",
      mission: "",
      vision: ""
    }
  ]);

  return (
    <>
      <Header />
      <Breadcrumb title="Student Clubs" tabName="Clubs" />

      <div className="innerPage ncsr-clubs-page">
        <div className="container">
          {/* Hero Section with Introduction */}
          <div className="row clubs-intro-section">
            <div className="col-md-12">
              <div className="clubs-hero-content">
                <h2 className="clubs-main-title">NCS - CLUBS</h2>
                <p className="clubs-intro-text">
                  At Nirmala Convent School, education extends far beyond the boundaries of the classroom.
                  Our vibrant student clubs provide a dynamic platform where students discover their passions,
                  develop their talents, and cultivate the essential skills needed to thrive in an ever-evolving world.
                </p>

                <div className="clubs-benefits">
                  <p>
                    Each club is thoughtfully designed to foster creativity, critical thinking, communication,
                    collaboration, leadership, innovation, and social responsibility. Through engaging activities,
                    workshops, competitions, projects, and community outreach initiatives, students gain meaningful
                    hands-on experiences that bridge the gap between academic learning and real-world application.
                  </p>
                </div>

                <div className="clubs-impact">
                  <p>
                    Our clubs inspire students to think independently, work collaboratively, lead with integrity,
                    and contribute positively to society. They encourage young learners to become confident communicators,
                    innovative problem-solvers, compassionate individuals, and responsible global citizens.
                  </p>
                </div>

                <div className="clubs-vision">
                  <p>
                    At Nirmala Convent School, we believe that today's learners are tomorrow's leaders. Our student clubs
                    play a pivotal role in transforming potential into purpose, empowering every student with the confidence,
                    character, and competencies required for success in higher education, future careers, and life beyond school.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Club Cards Section - Will be populated with club data */}
          {clubs.length > 0 && (
            <div className="row clubs-grid-section">
              {clubs.map((club) => (
                <div key={club.id} className="col-md-6 col-lg-4 clubs-card-wrapper">
                  <div className="club-card">
                    {club.image && (
                      <LazyLoad>
                        <div className="club-card-image">
                          <img
                            src={club.image}
                            alt={club.name}
                            className="img-fluid"
                          />
                        </div>
                      </LazyLoad>
                    )}
                    <div className="club-card-content">
                      <h3 className="club-card-title">{club.name}</h3>
                      <p className="club-card-description">{club.description}</p>

                      {club.mission && (
                        <div className="club-card-section">
                          <h4 className="club-card-section-title">Mission</h4>
                          <p className="club-card-section-text">{club.mission}</p>
                        </div>
                      )}

                      {club.vision && (
                        <div className="club-card-section">
                          <h4 className="club-card-section-title">Vision</h4>
                          <p className="club-card-section-text">{club.vision}</p>
                        </div>
                      )}

                      {club.details && (
                        <ul className="club-card-details">
                          {club.details.map((detail, index) => (
                            <li key={index}>{detail}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Clubs;